<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.roleName" placeholder="请输入角色类型"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="roleName" label="角色类型" align="center">
				</el-table-column>
				<el-table-column prop="roleDesc" label="描述" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="warning" @click="jurisdiction(scope.row)">权限分配</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="角色类型" label-width='100px'>
					<el-input v-model="form.roleName" maxlength="18" autocomplete="off" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="描述" label-width='100px'>
					<el-input v-model="form.roleDesc" maxlength="10" autocomplete="off" placeholder="请输入用户名称">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="权限分配" :visible.sync="settingDialogVisible" :modal-append-to-body='false' width="600px">
			<el-tree :data="menuData" :props='props' ref="tree" show-checkbox node-key="pkPermsId" default-expand-all>
			</el-tree>
			<div slot="footer" class="dialog-footer">
				<el-button @click="settingDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="jurisdictionSub">确 定</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectTableData: [],
				tableData: [],
				total: 0,
				dialogVisible: false,
				settingDialogVisible: false,
				isAdd: true,
				secah: {
					pageSize: 10,
					pageNum: 1,
					roleName: ""
				},
				form: {
					roleDesc: "",
					roleName: "",
					enableStatus: 1,
				},
				menuData: [],
				jurisdictionMenuData:[],
				props:{
					label:"menuName",
					children:"child"
				},
				roleId:""

			}
		},
		created() {
			this.getRoleList()
			this.getMenu()
			// this.setting()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getRoleList()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form = {
					roleDesc: "",
					roleName: "",
					enableStatus: 1,
				}
			},
			//提交
			sub() {
				if (this.form.roleName.length == 0) {
					this.$message('请输入角色名称');
					return false
				}

				var url = this.isAdd ? "/system/role/add" : "/system/role/update"
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getRoleList()
						}
					})
				} else {
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getRoleList()
						}
					})
				}

			},

			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/system/role/del?" + this.$qs.stringify({
						pkRoleId: row.pkRoleId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getRoleList()
						}
					})
				}).catch(() => {});
			},
			//修改
			edit(row) {
				console.log(row);
				this.dialogVisible = true
				this.isAdd = false
				this.form = JSON.parse(JSON.stringify(row))
				// this.form.password=''

			},


			//权限分配
			jurisdiction(row) {
				this.settingDialogVisible = true
				this.getSelectMenus(row.pkRoleId)
				this.roleId=row.pkRoleId
			},
			//确定分配
			jurisdictionSub() {				
				var obj = {
					roleId:this.roleId,
					permsIds:this.$refs.tree.getHalfCheckedKeys().concat(this.$refs.tree.getCheckedKeys())}
				this.httpPost("/system/role/batchRolePerms",obj,true, {
						'Content-Type': 'application/json'
					}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.$message.success('操作成功');
						this.settingDialogVisible = false
						this.getRoleList()
					}
				})
			},
			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getUserList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getUserList()
			},
			//获取数据
			getRoleList() {
				this.httpPost("/system/role/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})
			},
			//获取菜单数据
			getMenu() {
				this.httpPost("/system/role/selectMenus", {}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.menuData = res.data
					}
				})
			},
			//获取角色菜单数据
			getSelectMenus(id) {
				this.httpPost("/system/role/selectMenus?"+this.$qs.stringify({fkRoleId:id})).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.$nextTick(() => {
							  this.$refs.tree.setCheckedKeys(this.menuIds(res.data));
						});
					}
				})
			},
			menuIds(arr){
				var ids=[]
				for(var i=0;i<arr.length;i++){
					var item=arr[i]
					// ids.push(item.pkPermsId)
					if(item.child.length>0){
						for(var n=0;n<item.child.length;n++){
							ids.push(item.child[n].pkPermsId)
						}
					}
				}
				return ids
			}

		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
